import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {

  async getDaesPeriodo ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/daesPeriodo`,
      data: filtro
    })

    return data
  },

  async getDaesMunicipio ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/daesMunicipio`,
      data: filtro
    })

    return data
  },

  async getDaesMunicipioPaginado ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/daesMunicipioPaginado`,
      data: filtro
    })

    return data
  },

  async getDaesTipoProcesso ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/daesTipoProcesso`,
      data: filtro
    })

    return data
  },

  async getDaesTipoProcessoPaginado ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/daesTipoProcessoPaginado`,
      data: filtro
    })

    return data
  },

  async getTotalDaes ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/totalDaes`,
      data: filtro
    })

    return data
  },

  async getCSVDaesByTipo ({ commit }, data) {
    await axios({
      method: 'POST',
      url: `${modulo.FINANCEIRO}/relatorioDae/getCSVDaesByTipo`,
      data,
      responseType: 'blob'
    })
  },

  // Exporta csv DAEs com o filtro escolhido
  async getCSVDaesByMunicipio({ commit }, data) { // eslint-disable-line
    await axios({
      method: 'post',
      url: `${modulo.FINANCEIRO}/relatorioDae/getCSVDaesByMunicipio`,
      data,
      responseType: 'blob'
    })
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/financeiro/relatoriosDae.js